/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


export const toCamelKey = (key) =>
{
  return key.replace(/_(\w)/g, (match, letter) => letter.toUpperCase()).replace(/Id$/, 'ID');
};


export const toUnderscoreKey = (key) =>
{
  return key.replace(/ID$/, 'Id').replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);
};


// Dates arrive as {date, diff}; date is kept as is on the server clock (eve delay already baked in).
const isDate = (value) =>
{
  return value.date !== undefined && value.diff !== undefined;
};


const toCamelValue = (value) =>
{
  if (Array.isArray(value))
  {
    return value.map(toCamelValue);
  }

  if (value === null || typeof value !== 'object')
  {
    return value;
  }

  if (isDate(value))
  {
    return value.date;
  }

  const result = {};

  for (const [key, entry] of Object.entries(value))
  {
    result[toCamelKey(key)] = toCamelValue(entry);
  }

  return result;
};


export const toCamelKeys = (value) =>
{
  return toCamelValue(value);
};


export const toUnderscoreKeys = (value) =>
{
  if (Array.isArray(value))
  {
    return value.map(toUnderscoreKeys);
  }

  if (value === null || typeof value !== 'object')
  {
    return value;
  }

  const result = {};

  for (const [key, entry] of Object.entries(value))
  {
    result[toUnderscoreKey(key)] = toUnderscoreKeys(entry);
  }

  return result;
};


export class Standard
{
  routing (segments)
  {
    return segments.map(toCamelKey);
  }


  inbound (data)
  {
    return toCamelKeys(data);
  }


  path (path)
  {
    return path.split('/').map(toUnderscoreKey).join('/');
  }


  outbound (json)
  {
    return toUnderscoreKeys(json);
  }

};


export class Identity
{
  routing (segments)
  {
    return segments;
  }


  inbound (data)
  {
    return data;
  }


  path (path)
  {
    return path;
  }


  outbound (json)
  {
    return json;
  }

};
